import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button, Menu, MenuItem } from "@mui/material"
import { UnityEnum } from "constants/unity"

const UnityWithMenu = ({
  value,
  onChange,
  disabled,
  onBeforeOpen,
  disabledStyle = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    if (!disabled) {
      if (onBeforeOpen) {
        try {
          onBeforeOpen()
        } catch (e) {
          console.error("Error en onBeforeOpen:", e)
        }
      }
      setAnchorEl(event.currentTarget)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = newValue => {
    onChange(newValue)
    handleClose()
  }

  return (
    <>
      <Button
        onClick={handleClick}
        size="small"
        disabled={disabledStyle ? disabled : false}
        variant="text"
        sx={{
          minWidth: "auto",
          p: 0.5,
          fontSize: "0.875rem",
          textTransform: "none",
          color: "text.primary",
          cursor: disabled && !disabledStyle ? "default" : "pointer",
        }}
      >
        {value || "pa"}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {Object.values(UnityEnum).map(unity => (
          <MenuItem
            key={unity}
            onClick={() => handleSelect(unity)}
            selected={value === unity}
          >
            {unity}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

UnityWithMenu.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onBeforeOpen: PropTypes.func,
  disabledStyle: PropTypes.bool,
}

export default UnityWithMenu
